export default __webpack_public_path__ + "static/media/dz.72f4e712.svg";